import dayjs from 'dayjs';

export default {
  install(Vue) {
    Vue.filter('formatDate', (value, format = 'YYYY-MM-DD HH:mm:ss') => {
      if (!value) return dayjs().format(format);
      return dayjs(value).format(format);
    });
  }
};
